<template>
  <div class="container my-4">
    <router-link :to="{ name: 'ConfigurationsView', query: { deviceName: encodeURI(this.deviceName) } }">
      <fa-icon :icon="['fas', 'chevron-left']" class="mr-2" />{{ deviceName }} Konfigurationen
    </router-link>
    <h4 class="mt-3 mb-4">{{ deviceName }} Konfiguration bearbeiten</h4>
    <form v-on:submit.prevent="speichereKonfiguration" v-if="isLoading === false">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="font-weight-bold">Bezeichnung CTO-Finder</label>
            <input type="text" class="form-control" v-model="name" placeholder='Apple iMac 5K 68,6cm(27") CTO' />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Bezeichnung Deluxe (ohne Prozessor)</label>
            <input type="text" class="form-control" v-model="deluxeName" placeholder='Apple iMac 5K 68,6cm(27") CTO' />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Hersteller-Artikelnummer</label>
            <input type="text" class="form-control" v-model="herstellernummer" placeholder="MRR12D/A" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Artikel-Nr. Standardkonfiguration</label>
            <input type="text" class="form-control" v-model="artikelNrStandardkonfig" placeholder="PWAN-99513" />
          </div>
          <div class="form-group">
            <UploadImageComponent :configurationId="generiereId(16)" v-on:imageUpload="imageUpload" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Aktuelles Bild</label>
            <img :src="aktuellesBild" class="img-fluid" id="bild" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Sichtbarkeit</label>
            <b-form-checkbox v-model="visibility.comlineshop">
              ComLine Shop
            </b-form-checkbox>
            <b-form-checkbox v-model="visibility.clrent">
              CLRent
            </b-form-checkbox>
            <b-form-checkbox v-model="visibility.ctoAtWebAndStore">
              CTO@Web/-Store
            </b-form-checkbox>
            <b-form-checkbox v-model="visibility.debug">
              <b>DEBUG</b>
            </b-form-checkbox>
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Filter</label>
            <div v-for="(filterkategorie, filterkategorieIndex) in filter"
              :key="'filterkategorie-' + filterkategorieIndex" class="mb-2">
              <h6>{{ filterkategorie.name }}</h6>
              <b-form-checkbox v-for="(filter, filterIndex) in filterkategorie.filter" :key="'filter-' + filterIndex"
                v-model="gewaehlteFilter[filter.id]">
                {{ filter.name }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Status</label>
            <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select>
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Artikelnummer Präfix</label>
            <input type="text" class="form-control" v-model="artikelnummerPraefix" placeholder="C" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Produktcode</label>
            <input type="text" class="form-control" v-model="code" placeholder="Z0VT" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Datenblatt-Dateiname</label>
            <input type="text" class="form-control" v-model="datenblatt" placeholder="iMac_03-2019.pdf" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Deluxe-Warengruppe</label>
            <input type="text" class="form-control" v-model="warengruppe" placeholder="Apple CPU CTO iMac STD" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">VP-Netto ohne UHG (&euro;)</label>
            <input type="number" class="form-control" step="0.01" v-model.number="dac" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">UHG (&euro;)</label>
            <input type="number" class="form-control" step="0.01" v-model.number="uhg" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">UVP-Brutto (&euro;)</label>
            <input type="number" class="form-control" step="0.01" v-model.number="uvpBrutto" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Skonto R1 (%)</label>
            <input type="number" class="form-control" step="0.01" v-model.number="skontoR1" />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Deluxe-Beschreibungstext</label>
            <textarea class="form-control" rows="5" v-model="deluxeBeschreibungstext"></textarea>
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Shop-Beschreibungstext</label>
            <textarea class="form-control" rows="12" v-model="shopBeschreibungstext"></textarea>
          </div>
        </div>
      </div>

      <b-form-group>
        <b-card class="shadow-sm">
          <label class="font-weight-bold mb-3">Komponenten</label>
          <new-draggable-component :group="'komponenten'" :itemName="'name'" :availableItems="verfuegbareKomponenten"
            :selectedItems="gewaehlteKomponenten" :availableItemsHeading="'Verfügbare Komponenten'"
            :selectedItemsHeading="'Gewählte Komponenten'" v-on:savedLinkedOptions="savedLinkedOptions">
          </new-draggable-component>
        </b-card>
      </b-form-group>

      <button type="submit" class="btn btn-primary">Speichern</button>
    </form>
    <SpinnerComponent v-else />
  </div>
</template>

<script>
import SpinnerComponent from "../components/SpinnerComponent";
import UploadImageComponent from "../components/UploadImageComponent";
import NewDraggableComponent from "../components/NewDraggableComponent";

import { firestore } from "../plugins/firebase"
import { getDoc, doc, query, getDocs, orderBy, collection, setDoc } from "firebase/firestore"

export default {
  name: "EditConfigurationView",
  components: {
    NewDraggableComponent,
    UploadImageComponent,
    SpinnerComponent,
  },
  computed: {
    deviceName: function () {
      return decodeURI(this.$route.query.deviceName);
    },
    deviceId: function () {
      return this.$route.params.deviceId;
    },
    configurationId: function () {
      return this.$route.params.configurationId;
    },
  },
  data() {
    return {
      isLoading: true,
      orderIndex: 99,
      name: "",
      deluxeName: "",
      artikelnummerPraefix: "C",
      code: "",
      dac: 0,
      datenblatt: "",
      herstellernummer: "",
      artikelNrStandardkonfig: "",
      skontoR1: 0.3,
      uhg: 0,
      uvpBrutto: 0,
      warengruppe: "",
      deluxeBeschreibungstext:
        "CTO Variante der Grundkonfiguration [SPEZIFIKATIONEN] ##Urheberrechtsabgabe nach §54a UrhG abgeführt und im Kaufpreis enthalten - Artikel auftragsbezogen bestellt, Stornierung oder Rückgabe ausgeschlossen - We can not accept a cancellation or return for this build to order configuration.",
      shopBeschreibungstext:
        "<b>Apple CTO Rechner werden im Kundenauftrag bestellt und gefertigt. Nach erfolgtem Auftragseingang können diese CTO Rechner nicht mehr storniert werden und sind somit von der Rückgabe ausgeschlossen. Apple CTO computers are ordered and assembled on customers demand. After reciept of order CTO computers can not be canceled and are thereby excluded from return.<br><br>Spezifikationen:</b> [SPEZIFIKATIONEN] <br><br>- Urheberrechtsabgabe nach §54a UrhG abgeführt und im Kaufpreis enthalten - Artikel auftragsbezogen bestellt, Stornierung oder Rückgabe ausgeschlossen - We can not accept a cancellation or return for this build to order configuration.",
      gewaehlteKomponenten: [],
      verfuegbareKomponenten: [],
      selectedStatus: "",
      aktuellesBild: "",
      neuesBild: "",
      statusOptions: [
        {
          value: "",
          text: "-",
        },
        {
          value: "in-kuerze-verfuegbar",
          text: "In Kürze verfügbar",
        },
        {
          value: "wartung",
          text: "In Wartung",
        },
        {
          value: "neu",
          text: "Neu",
        },
      ],
      visibility: {
        comlineshop: false,
        clrent: false,
        ctoAtWebAndStore: false,
        debug: true,
      },
      filter: [],
      gewaehlteFilter: {},
    };
  },
  async mounted() {
    const promises = [
      this.ladeKonfiguration(),

      getDocs(query(collection(firestore, 'komponenten'), orderBy("name", "asc"))),

      getDocs(collection(firestore, "filter")),
    ];

    Promise.all(promises)
      .then((responses) => {
        if (responses[0].data().visibility !== undefined) {
          this.visibility = responses[0].data().visibility;
        }
        this.selectedStatus = responses[0].data().selectedStatus;
        this.name = responses[0].data().name;
        this.deluxeName = responses[0].data()?.deluxeName || "";
        this.orderIndex = responses[0].data().orderIndex;
        this.aktuellesBild = responses[0].data().bild;
        this.neuesBild = responses[0].data().bild;
        this.artikelnummerPraefix = responses[0].data().artikelnummerPraefix;
        this.code = responses[0].data().code;
        this.dac = responses[0].data().dac;
        this.datenblatt = responses[0].data().datenblatt;
        this.herstellernummer = responses[0].data().herstellernummer;
        this.artikelNrStandardkonfig = responses[0].data().artikelNrStandardkonfig;
        this.referenz = responses[0].data().referenz;
        this.skontoR1 = responses[0].data().skontoR1;
        this.uhg = responses[0].data().uhg;
        this.uvpBrutto = responses[0].data().uvpBrutto;
        this.warengruppe = responses[0].data().warengruppe;
        this.deluxeBeschreibungstext = responses[0].data().deluxeBeschreibungstext;
        this.shopBeschreibungstext = responses[0].data().shopBeschreibungstext;
        this.gewaehlteKomponenten = responses[0].data().gewaehlteKomponenten;

        if (responses[0].data().gewaehlteFilter !== undefined) {
          this.gewaehlteFilter = responses[0].data().gewaehlteFilter;
        }

        const gewaehlteKomponentenIds = this.gewaehlteKomponenten.map((element) => element.id);

        responses[1].forEach((document) => {
          if (gewaehlteKomponentenIds.includes(document.id) === false) {
            const element = {
              id: document.id,
              data: document.data(),
            };
            this.verfuegbareKomponenten.push(element);
          }
        });

        responses[2].forEach((document) => {
          if (document.data().deviceId === this.deviceId) {
            this.filter.push(document.data());
          }
        });

        this.isLoading = false;
      })
      .catch((error) => {
        console.error(error);
        this.$bvModal
          .msgBoxOk("Daten konnten nicht geladen werden.", {
            title: "",
            okVariant: "primary",
            okTitle: "OK",
            hideHeaderClose: false,
            noCloseOnBackdrop: true,
          })
          .then(() => this.$router.replace("/verwaltung/konfigurationen"))
          .catch((error) => console.error(error)); // eslint-disable-line no-console
      });
  },
  methods: {
    savedLinkedOptions(data) {
      console.log("find this", data)
      this.gewaehlteKomponenten.forEach((komponente) => {
        komponente.data.optionen.forEach((option) => {
          if (option.id === data.originOption) {
            typeof komponente.linkedOptions != 'object' && (komponente.linkedOptions = {})
            komponente.linkedOptions[data.originOption] = data.linkedOptions;
            console.log("Komponente", komponente)
          }
        });
      });
    },
    ladeKonfiguration: function () {
      return getDoc(doc(firestore, "konfigurationen", this.configurationId))
        .then((doc) => {
          if (doc.exists) {
            return doc;
          } else {
            return new Error();
          }
        });
    },
    imageUpload: function (url) {
      this.neuesBild = url;
    },
    generiereId: function (idLength) {
      const alphaNum = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let id = "";
      for (let i = 0; i < idLength; i++) {
        id += alphaNum.charAt(Math.floor(Math.random() * alphaNum.length));
      }
      return id;
    },
    speichereKonfiguration: function () {
      setDoc(doc(firestore, "konfigurationen", this.configurationId), {
        visibility: this.visibility,
        selectedStatus: this.selectedStatus,
        bild: this.neuesBild,
        orderIndex: this.orderIndex,
        name: this.name.trim().replace(/[‘´'´]+/g, '"'),
        deluxeName: this.deluxeName.trim().replace(/[‘´'´]+/g, '"'),
        artikelnummerPraefix: this.artikelnummerPraefix,
        code: this.code,
        dac: this.dac,
        deviceId: this.deviceId,
        datenblatt: this.datenblatt,
        herstellernummer: this.herstellernummer,
        artikelNrStandardkonfig: this.artikelNrStandardkonfig,
        skontoR1: this.skontoR1,
        uhg: this.uhg,
        uvpBrutto: this.uvpBrutto,
        warengruppe: this.warengruppe,
        deluxeBeschreibungstext: this.deluxeBeschreibungstext,
        shopBeschreibungstext: this.shopBeschreibungstext,
        gewaehlteKomponenten: this.gewaehlteKomponenten,
        gewaehlteFilter: this.gewaehlteFilter,
      })
        .then(() =>
          this.$router.push({
            name: "ConfigurationsView",
            query: {
              deviceName: encodeURI(this.deviceName),
            },
          })
        )
        .catch((error) => console.error(error)); // eslint-disable-line no-console
    },
  },
};
</script>

<style scoped>
.dropzone {
  border: 1px dashed #ced4da;
}

.dropzone .card {
  cursor: move;
}
</style>
